<template>
    <div class="row">
        <div class="col">
            <div class="table-responsive-sm table-responsive-md">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" class="sticky-top bg-white border-top-0 m-0 p-0 pt-2">
                                <div class="border-bottom">
                                    <p>&nbsp;</p>
                                </div>
                            </th>
                            <th scope="col" class="sticky-top bg-white border-top-0 m-0 p-0 pt-2" v-for="bike in results">
                                <div class="border-bottom">
                                    <figure class="figure">
                                        <figcaption class="figure-caption">
                                        <h2 class="h6">{{ bike.make }} {{ bike.model }}</h2></figcaption>
                                        <img :src="'/images/' + bike.bikeid + '.jpg'" class="figure-img img-fluid rounded" :alt="bike.make + ' ' + bike.model">
                                    </figure>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row" class="w-25">Manufacturer</th>
                            <td v-for="bike in results">
                                <span>{{ bike.make }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Model</th>
                            <td v-for="bike in results">
                                <span>{{ bike.model }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Model ID</th>
                            <td v-for="bike in results">
                                <span>{{ bike.modelcode }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">First Production Year</th>
                            <td v-for="bike in results">
                                <span>{{ bike.startyr }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Last Production Year</th>
                            <td v-for="bike in results">
                                <span v-if="bike.endyr === '9999'">In production</span>
                                <span v-else>{{ bike.endyr }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Wikipedia</th>
                            <td v-for="bike in results">
                                <a v-if="bike.wiki !== '0'" :href="bike.wiki" target="_blank" rel="noreferrer noopener" aria-label="Wikipedia (opens in a new tab)">Wikipedia</a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">MotorCycleSpecs</th>
                            <td v-for="bike in results">
                                <a v-if="bike.moto !== '0'" :href="bike.moto" target="_blank" rel="noreferrer noopener" aria-label="MotorCycleSpecs (opens in a new tab)">MotorCycleSpecs</a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Bikez</th>
                            <td v-for="bike in results">
                                <a v-if="bike.bikez !== '0'" :href="bike.bikez" target="_blank" rel="noreferrer noopener" aria-label="Bikez (opens in a new tab)">Bikez</a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Engine Displacement</th>
                            <td v-for="bike in results">
                                <span>{{ bike.engdisp[unit].toFixed(1) }} {{ bike.engdisp.measurement[unit] }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Engine Max Power</th>
                            <td v-for="bike in results">
                                <span>{{ bike.engmaxpwr[unit].toFixed(1) }} {{ bike.engmaxpwr.measurement[unit] }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">`@ (x) RPM</th>
                            <td v-for="bike in results">
                                <span>{{ bike.engmaxpwrrpm }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Max Torque</th>
                            <td v-for="bike in results">
                                <span v-if="unit === 'metric'">{{ bike.engmaxtrq[unit].toFixed(0) }} {{ bike.engmaxtrq.measurement[unit] }}</span>
                                <span v-else>{{ bike.engmaxtrq[unit].toFixed(3) }} {{ bike.engmaxtrq.measurement[unit] }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">`@ (x) RPM</th>
                            <td v-for="bike in results">
                                <span>{{ bike.engmaxtrqrpm }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Engine Power Density <span class="small">(How hard is this engine tuned)</span></th>
                            <td v-for="bike in results">
                                <span>{{ bike.engpwrdensity[unit].toFixed(2) }} {{ bike.engpwrdensity.measurement[unit] }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Fuel Delivery</th>
                            <td v-for="bike in results">
                                <span>{{ bike.engfueling }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Cooling Type</th>
                            <td v-for="bike in results">
                                <span>{{ bike.engcooling }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Cylinder Qty</th>
                            <td v-for="bike in results">
                                <span>{{ bike.engcylinders }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Gear Qty</th>
                            <td v-for="bike in results">
                                <span>{{ bike.enggearqty }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Oil Change (Service) Interval</th>
                            <td v-for="bike in results">
                                <span>{{ parseFloat(bike.engsvcinterval).toFixed(0)}}</span>
                                <span v-if="unit === 'metric'"> km</span>
                                <span v-else> mi</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Front Wheel Travel</th>
                            <td v-for="bike in results">
                                <span v-if="unit === 'metric'">{{ bike.wheeltravelfrt[unit].toFixed(0) }} {{ bike.wheeltravelfrt.measurement[unit] }}</span>
                                <span v-else>{{bike.wheeltravelfrt[unit].toFixed(1) }} {{ bike.wheeltravelfrt.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Rear Wheel Travel</th>
                            <td v-for="bike in results">
                                <span v-if="unit === 'metric'"> {{ bike.wheeltravelrear[unit].toFixed(0) }} {{ bike.wheeltravelrear.measurement[unit] }}</span>
                                <span v-else>{{ bike.wheeltravelrear.us.toFixed(1) }} {{ bike.wheeltravelrear.measurement[unit] }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Front Wheel Size</th>
                            <td v-for="bike in results">
                                <span>{{ bike.wheeldiafrt }} in</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Rear Wheel Size</th>
                            <td v-for="bike in results">
                                <span>{{ bike.wheeldiarear }} in</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Wheel Constuction</th>
                            <td v-for="bike in results">
                                <span>{{ bike.wheeltype }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Final Drive</th>
                            <td v-for="bike in results">
                                <span> {{ bike.finaldrive }} </span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">ABS</th>
                            <td v-for="bike in results">
                                <span>{{ bike.bikeabs }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Traction Control</th>
                            <td v-for="bike in results">
                                <span>{{ bike.biketc }}</span>
                            </td>
                        </tr>  
                        <tr>
                            <th scope="row" class="w-25">Weight Dry (OEM)</th>
                            <td v-for="bike in results">
                                <span>{{ bike.bikewtdry[unit].toFixed(0) }} {{ bike.bikewtdry.measurement[unit] }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Weight Wet</th>
                            <td v-for="bike in results">
                                <span>{{ bike.bikewtwet[unit].toFixed(0) }} {{ bike.bikewtwet.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Wet Weight used for Calculations</th>
                            <td v-for="bike in results">
                                <span>{{ bike.wetweightcalc[unit].toFixed(0) }} {{ bike.wetweightcalc.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">OEM Fuel Economy Specification</th>
                            <td v-for="bike in results">
                                <span>{{ bike.bikefueleconspec[unit].toFixed(1) }} {{ bike.bikefueleconspec.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Fuelly Fuel Economy Statistics</th>
                            <td v-for="bike in results">
                                <span>{{ bike.fuellydata[unit].toFixed(1) }} {{ bike.fuellydata.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Fuel Economy for Range Calculations </th>
                            <td v-for="bike in results">
                                <span>{{ bike.bikefueleconcomb[unit].toFixed(1) }} {{ bike.bikefueleconcomb.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Fuel Tank Size</th>
                            <td v-for="bike in results">
                                <span v-if="unit === 'metric'"> {{ bike.bikefuelcap[unit] }} {{ bike.bikefuelcap.measurement[unit] }}</span>
                                <span v-else>{{ bike.bikefuelcap[unit].toFixed(3) }}  {{ bike.bikefuelcap.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Fuel Range with Builtin Tank</th>
                            <td v-for="bike in results">
                                <span>{{ bike.range[unit].toFixed(0) }} {{ bike.range.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Fuel Required for Target Range</th>
                            <td v-for="bike in results">
                                <span>{{ bike.fuelrequired[unit].toFixed(0) }} {{ bike.fuelrequired.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Additional fuel required over builtin Tank</th>
                            <td v-for="bike in results">
                                <span v-if="bike.extrafuelrequired[unit] > 0">{{ bike.extrafuelrequired[unit].toFixed(0) }} {{ bike.extrafuelrequired.measurement[unit] }}</span>
                                <span v-else>0.0 {{ bike.extrafuelrequired.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Est.Weight of Extra Fuel + Container + Mount</th>
                            <td v-for="bike in results">
                                <span>{{ bike.extrafuelweight[unit].toFixed(0) }} {{ bike.extrafuelweight.measurement[unit] }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Full Bike Weight - Wet + Extra Fuel + Luggage + Farkles <span class="small">(What you have to pick up when you drop it)</span></th>
                            <td v-for="bike in results">
                                <span :class="{ 'text-warning': bike.bikewtwet[unit] === 0 }">{{ bike.fullbikeweight[unit].toFixed(0) }} {{ bike.fullbikeweight.measurement[unit] }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Full Bike &amp; Rider Weight - As Above + Rider + Rider Gear <span class="small">(GVM - Gross Vehicle Mass)</span></th>
                            <td v-for="bike in results">
                                <span :class="{ 'text-warning': bike.bikewtwet[unit] == 0 }">{{ bike.fullbikeweightwrider[unit].toFixed(0) }} {{ bike.fullbikeweightwrider.measurement[unit] }}</span>
                            </td>
                        </tr> 
                        <tr>
                            <th scope="row" class="w-25">Power to Weight Ratio (OEM, Wet Weight)</th>
                            <td v-for="bike in results">
                                <span :class="{ 'text-warning': bike.bikewtwet[unit] == 0 }"> {{ bike.powertoweight[unit].toFixed(3) }} {{ bike.powertoweight.measurement[unit] }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="w-25">Power to Full Bike &amp; Rider Weight <span class="small">(How fast will you accelerate)</span></th>
                            <td v-for="bike in results">
                                <span :class="{ 'text-warning': bike.bikewtwet[unit] == 0 }"> {{ bike.powertofullweight[unit].toFixed(3) }} {{ bike.powertofullweight.measurement[unit] }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import EventBus from '../eventbus';
    import {mapGetters} from 'vuex';
    export default {
        name: "Resultspage",
        components: {},
        data() {
            return {
                bikes: [],
            }
        },
        created() {
            this.bikes = this.$route.params.bikeids.split('-');
            this.$store.dispatch('BikeDataStore/getRouterQuery', this.$route.query);
        },
        methods: {
            getResults(bikes) {
                return bikes.map(item => {
                    
                    return item;
                });
            }            
        },
        computed: {
            ...mapGetters({
                data: 'BikeDataStore/getResults',
                unit: 'BikeDataStore/getMeasurement',
                inputs: 'BikeDataStore/getInputs'
            }),
            results() {
                const resultList = this.data;  
                let bikesComparison = resultList.filter(item => this.bikes.includes(item.bikeid)); 
                let bikenames = bikesComparison.map(item => `${item.make.trim().replace(/ /g, '-')}-${item.model.trim().replace(/ /g, '-')}`);
                document.title = `${bikenames.join('-vs-').replace(/-/g, ' ')} | Compare Adventure Motorcycle Spec’s`;
                document.querySelector('link[rel="canonical"]').href= `https://www.advspecs.com/compare/${bikenames.join('-vs-')}/${this.$route.params.bikeids}/`;
                return this.getResults(bikesComparison);
            },
        },
        
    }
</script>